import Translation from "src/translations/locales/translation";

import { TFunction } from "i18next";

export default class PasswordValidator {
  private _t: TFunction;

  constructor(t: TFunction) {
    this._t = t;
  }

  /**
   * Validates a password for strength and format.
   * Rules:
   * - Minimum 8 characters
   * - At least one uppercase letter
   * - At least one lowercase letter
   * - At least one number
   * - At least one special character
   */
  validatePassword = (password: string): string | null => {
    // Regular expression enforcing strong password rules
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{8,}$/;

    // Validate
    if (passwordRegex.test(password.trim())) {
      // Valid
      return null;
    }

    // Invalid
    return this._t(Translation.common.validators.password);
  };
}
